import React from 'react';
import PropTypes from 'prop-types';
import {
  IncludedRelationshipProvider,
  useIncludedRelationshipContext,
} from 'Views/Page/Contexts/IncludedRelationshipContext';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import classNames from 'classnames';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';

const TableContent = withStyles(theme => ({
  head: {
    '& th': {
      backgroundColor: theme.palette.facet.backgroundGray,
    },
  },
  cell: {
    padding: theme.spacing(1),
    '& .MuiTypography-root': {
      ...theme.typography.body1,
      overflow: 'hidden',
      fontWeight: theme.typography.fontWeightBold,
      textAlign: 'right',
      textOverflow: 'ellipsis',
    },
  },
  tableNavigation: {
    display: 'none',
  },
}))(({ classes }) => {
  const { relationshipCollection } = useIncludedRelationshipContext();
  return relationshipCollection && (
    <MetaTable
      tableMetaOverrideSetName={'FacetPlanAccount'}
      collection={relationshipCollection}
      features={{}}
      classes={classes}
      CellProps={{
        classes: {
          root: classes.cell,
        },
      }}
      columns={[
        { name: 'name' },
        { name: 'balance' },
        { name: 'ownerName' },
        { name: 'accountType' },
        { name: 'institution' },
        {
          name: 'interestRate',
        },
      ]}
    />
  );
});

const AccountTable = ({ resource, classes }) => {
  if (!resource.relationship('virtualAccounts')?.data.length) {
    return (
      <Box className={classNames(classes.root)}>
        <Alert severity={'info'}>{'No accounts have been added to this Outcome.'}</Alert>
      </Box>
    );
  }

  return (
    <Box className={classNames(classes.root)} test={'facet-plan-summary-card-accounts'}>
      <Typography
        className={classNames(classes.title)}
        variant={'body1'}
        weight={'medium'}
        color={'black'}
      >
        {'Accounts'}
      </Typography>
      <IncludedRelationshipProvider relationship={resource.relationship('virtualAccounts')}>
        <TableContent />
      </IncludedRelationshipProvider>
    </Box>
  );
};


AccountTable.propTypes = {
  resource: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles({ root: {}, title: {} })(AccountTable);
